/* luma-atc.js — restores the AddToCart pixel event.
 *
 * Why this exists: the v19 buy box adds to cart with a plain form POST, which
 * hard-navigates to /cart. Nothing in the theme ever called fbq('track','AddToCart'),
 * and Shopify's own web pixel does not emit one on that path — verified 20 Aug 2026:
 * a successful add produced exactly one facebook.com/tr request, ev=PageView.
 * Result: ~64 landing page views with 0 recorded carts, and a Purchase-optimised
 * campaign running with no mid-funnel signal at all.
 *
 * Deliberately does NOT intercept the form. It only reads /cart.js on page load and
 * compares against the previous snapshot, so a failure here can never block a sale.
 */
(function () {
  var KEY = 'luma_atc_snap';

  function snapshot(items) {
    var o = {};
    (items || []).forEach(function (i) { o[i.key] = i.quantity; });
    return o;
  }

  function report(delta, items) {
    if (typeof window.fbq !== 'function') return;
    var ids = [], contents = [], value = 0;
    items.forEach(function (i) {
      var d = delta[i.key];
      if (!d || d <= 0) return;
      ids.push(String(i.variant_id));
      contents.push({ id: String(i.variant_id), quantity: d, item_price: i.price / 100 });
      value += (i.price * d) / 100;
    });
    if (!ids.length) return;
    window.fbq('track', 'AddToCart', {
      content_type: 'product',
      content_ids: ids,
      contents: contents,
      value: Number(value.toFixed(2)),
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
    });
  }

  function run() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var now = snapshot(cart.items), prevRaw = null;
        try { prevRaw = sessionStorage.getItem(KEY); } catch (e) {}
        try { sessionStorage.setItem(KEY, JSON.stringify(now)); } catch (e) {}

        // First page of a session only establishes the baseline. Without this a
        // returning shopper who lands straight on /cart would log a phantom add.
        if (prevRaw === null) return;

        var prev = {};
        try { prev = JSON.parse(prevRaw) || {}; } catch (e) {}

        var delta = {}, any = false;
        Object.keys(now).forEach(function (k) {
          var d = now[k] - (prev[k] || 0);
          if (d > 0) { delta[k] = d; any = true; }
        });
        if (any) report(delta, cart.items);
      })
      .catch(function () { /* tracking must never surface an error to a shopper */ });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
